import { Form } from "@circle-react-uikit/Form";
import { ASPECT_RATIO } from "@circle-react/components/constants";
import { CompassLikeImageInput } from "@circle-react/components/Drawers/CustomizeSpaceDrawerCompass/Shared/CompassLikeImageInput";

import { t } from "@/i18n-js/instance";

interface ThumbnailImageFieldProps {
  onProcessing: (isProcessing: boolean) => void;
}

export const ThumbnailImageField = ({
  onProcessing,
}: ThumbnailImageFieldProps) => (
  <Form.Item
    name="thumbnail_image"
    hideDescription
    label={t("courses.create_modal.course_thumbnail")}
    hideBorder
    fullWidth
    variant="extra-bottom-margin"
    className="!flex flex-col items-stretch gap-2 md:!flex-row md:items-start md:gap-4"
    labelClassName="!text-label-sm"
    labelWrapperClassName="min-w-0 !w-full md:!w-[30%]"
  >
    <CompassLikeImageInput
      name="thumbnail_image"
      alt={t("courses.create_modal.course_thumbnail")}
      aspectRatio={ASPECT_RATIO.SPACE_THUMBNAIL}
      className="md:!w-[70%]"
      customAspectRatioHelpText={t(
        "image_upload.recommended_size_space_thumbnail",
      )}
      emptyStateDescription={t(
        "spaces.form.edit.customize.course_thumbnail_image_description",
      )}
      emptyStateTitle={t("courses.create_modal.upload_image")}
      onProcessing={onProcessing}
      title={t("courses.create_modal.choose_image")}
    />
  </Form.Item>
);
